<template>
  <b-modal
    ref="OutstandingOrdersModal"
    title="Outstanding Orders"
    no-close-on-backdrop
    hide-footer
    size="lg"
    @shown="shown"
    @hidden="clear"
  >
    <div>
      <table class="table table-striped table-bordered" v-if="orders && orders.length">
        <thead>
          <tr>
            <th style="width: 25%;">ID</th>
            <th>Date added</th>
            <th>Qty</th>
            <th>Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order of orders" :key="order.order_id">
            <td>{{order.order_id}}</td>
            <td>{{order.date_added}}</td>
            <td>{{order.outstandingQty}}</td>
            <td>{{order.firstname + " " + order.lastname}}</td>
            <td>{{order.status}}</td>
          </tr>
        </tbody>
      </table>

      <div>
        <button class="btn btn-secondary mt-5 float-right text-white mr-2" @click="hideModal">Close</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "outstanding-orders-modal",
  props: ["model"],
  data() {
    return {
      orders: null
    };
  },
  methods: {
    shown() {
      this.$http
        .get(
          this.APIURL + this.BRAND + `/stock/outstanding-orders/${this.model}`
        )
        .then(
          response => {
            this.orders = response.data;
            this.orders.map(order => {
              order.outstandingQty = this.outstandingQty(order);
              return order;
            });
          },
          error => {
            console.log(error);
          }
        );
    },
    showModal() {
      this.$refs.OutstandingOrdersModal.show();
    },
    hideModal() {
      this.$refs.OutstandingOrdersModal.hide();
    },
    clear() {
      this.orders = null;
    },
    outstandingQty: function(order) {
      return order.items.filter(item => item.model === this.model)[0].quantity;
    }
  }
};
</script>
<style></style>
